<template>
  <div class="image-container" ref="imageContainer">
    <img 
      ref="imageRef"
      src="@/assets/A8F0402F-2EBA-421C-A945-86AB6C47F5F2.webp" 
      alt="Imagen de ejemplo" 
      class="cover-image"
    >
    <div class="overlay"></div>
    
    <div ref="textRef" class="text-overlay">
      <p class="firma">
        Con cariño,<br>
        <span>Alison</span>
      </p>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'CoverImageComponent',
  setup() {
    const imageRef = ref(null);
    const textRef = ref(null);
    const imageContainer = ref(null);

    onMounted(() => {
      // Creamos una línea de tiempo vinculada al scroll del contenedor
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: imageContainer.value,
          start: "top 80%", // Se activa cuando el tope del contenedor llega al 80% del viewport
          toggleActions: "play none none none",
        }
      });

      // 1. Animación de la imagen (Revelado con escala)
      tl.fromTo(imageRef.value, 
        { 
          opacity: 0, 
          scale: 1.1,
          filter: "brightness(150%) blur(10px)" // Efecto de flash inicial
        }, 
        { 
          opacity: 1, 
          scale: 1, 
          filter: "brightness(90%) blur(0px)",
          duration: 1.8, 
          ease: 'power2.out' 
        }
      );

      // 2. Animación del texto (Entra después de la imagen)
      tl.fromTo(textRef.value, 
        { 
          opacity: 0, 
          y: 40 
        }, 
        { 
          opacity: 1, 
          y: 0, 
          duration: 1.5, 
          ease: 'power3.out' 
        }, 
        "-=1" // Empieza 1 segundo antes de que termine la anterior para que se solapen
      );
    });

    return { textRef, imageRef, imageContainer };
  },
};
</script>

<style scoped>
.image-container {
  width: 100%;
  height: 600px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0; /* Color de fondo mientras carga */
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0; /* Aseguramos que GSAP la maneje */
  will-change: transform, opacity;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, transparent 50%, rgba(0,0,0,0.4));
  z-index: 5;
}

.text-overlay {
  position: absolute;
  bottom: 60px;
  width: 100%;
  text-align: center;
  color: #fff;
  z-index: 10;
  padding: 0 20px;
  /* Eliminamos el opacity: 0 del CSS para dejar que GSAP lo controle desde el fromTo */
}

.firma {
  font-size: 18px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 400;
  margin: 0;
  text-shadow: 0 2px 10px rgba(0,0,0,0.5);
}

.firma span {
  display: block;
  margin-top: 10px;
  font-family: 'FeelingPassionate', cursive;
  font-size: 3.5rem;
  line-height: 1.2;
}
</style>
